import { createSlice } from "@reduxjs/toolkit";
import { getChatThreads, getChatHistory } from "../Actions/chatData";

const initialState = {
  loading: false,
  threadsList: [],
  chatHistory: [],
  success: false
};

const ChatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    addMessageToHistory: (state, action) => {
      // Ensure we only add if chatHistory is an array
      if (Array.isArray(state.chatHistory)) {
        state.chatHistory.push(action.payload);
      } else {
        state.chatHistory = [action.payload];
      }
    },
    clearChatHistory: (state) => {
      state.chatHistory = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChatThreads.fulfilled, (state, { payload }) => {
        if (payload) {
          state.success = true;
          if (payload.data && Array.isArray(payload.data.threads)) {
            state.threadsList = payload.data.threads;
          } else if (Array.isArray(payload.data)) {
            state.threadsList = payload.data;
          } else if (Array.isArray(payload)) {
            state.threadsList = payload;
          } else {
            state.threadsList = [];
          }
        }
      })
      .addCase(getChatHistory.fulfilled, (state, { payload }) => {
        if (payload) {
          state.success = true;
          if (payload.data && Array.isArray(payload.data.messages)) {
            state.chatHistory = payload.data.messages;
          } else if (Array.isArray(payload.data)) {
            state.chatHistory = payload.data;
          } else if (Array.isArray(payload)) {
            state.chatHistory = payload;
          } else {
            state.chatHistory = [];
          }
        }
      });
  },
});

export const { addMessageToHistory, clearChatHistory } = ChatSlice.actions;
export default ChatSlice.reducer;
